export const VendorErrorState = {
  EVENT_STATE_UNKNOWN: 'EVENT_STATE_UNKNOWN',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  OFFLINE: 'OFFLINE',
  RECONNECTING: 'RECONNECTING',
  PAUSED: 'PAUSED',
  ON: 'ON',
  OFF: 'OFF',
  STANDBY: 'STANDBY',
  BOOTING: 'BOOTING',
  SHUTDOWN: 'SHUTDOWN',
  IDLE: 'IDLE',
  FAULTED: 'FAULTED',
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
  PREPARING: 'PREPARING',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
  TIMEOUT: 'TIMEOUT',
  LOCKED: 'LOCKED',
  UNLOCKED: 'UNLOCKED',
  JAMMED: 'JAMMED',
  INVALID_CODE: 'INVALID_CODE',
  AUTHORIZED: 'AUTHORIZED',
  UNAUTHORIZED: 'UNAUTHORIZED',
  REJECTED: 'REJECTED',
  RESERVED: 'RESERVED',
  ACCESS_REVOKED: 'ACCESS_REVOKED',
  COMPROMISED: 'COMPROMISED',
  QUARANTINED: 'QUARANTINED',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  PARTIALLY_OPEN: 'PARTIALLY_OPEN',
  FORCED_OPEN: 'FORCED_OPEN',
  STUCK: 'STUCK',
  NORMAL: 'NORMAL',
  TRIPPED: 'TRIPPED',
  CLEARED: 'CLEARED',
  TAMPERED: 'TAMPERED',
  DETECTED: 'DETECTED',
  STATIONARY: 'STATIONARY',
  EMPTY: 'EMPTY',
  OCCUPIED: 'OCCUPIED',
  HEALTHY: 'HEALTHY',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  CRITICAL_FAIL: 'CRITICAL_FAIL',
  BROKEN: 'BROKEN',
  PROVISIONING: 'PROVISIONING',
  COMMISSIONING: 'COMMISSIONING',
  DECOMMISSIONED: 'DECOMMISSIONED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  VIBRATING: 'VIBRATING',
  TILTED: 'TILTED',
  AUTO: 'AUTO',
  MANUAL_OVERRIDE: 'MANUAL_OVERRIDE',
  SCHEDULED: 'SCHEDULED',
  QUEUED: 'QUEUED',
  PENDING: 'PENDING',
  CHARGING: 'CHARGING',
  DISCHARGING: 'DISCHARGING',
  LOW_BATTERY: 'LOW_BATTERY',
  DEAD: 'DEAD',
  FLOWING: 'FLOWING',
  LEAKING: 'LEAKING',
  BLOCKED: 'BLOCKED',
  DRAINING: 'DRAINING',
  FILLING: 'FILLING',
  PRESSURIZING: 'PRESSURIZING',
  HEATING: 'HEATING',
  COOLING: 'COOLING',
  DEFROSTING: 'DEFROSTING',
  VENTILATING: 'VENTILATING',
  RECIRCULATING: 'RECIRCULATING',
  HIGH: 'HIGH',
  LOW: 'LOW',
  EXPIRED: 'EXPIRED',
  FAILURE: 'FAILURE',
  SUSPENDED_EV: 'SUSPENDED_EV',
  SUSPENDED_EVSE: 'SUSPENDED_EVSE',
  FINISHING: 'FINISHING',
  EV_CONNECTED: 'EV_CONNECTED',
  CONCURRENT_TX: 'CONCURRENT_TX',
  NO_CREDIT: 'NO_CREDIT',
  NOT_ALLOWED_TYPE_EVSE: 'NOT_ALLOWED_TYPE_EVSE',
  NOT_AT_THIS_LOCATION: 'NOT_AT_THIS_LOCATION',
  NOT_AT_THIS_TIME: 'NOT_AT_THIS_TIME',
  ACCEPTED: 'ACCEPTED',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  UNKNOWN_MESSAGE_ID: 'UNKNOWN_MESSAGE_ID',
  UNKNOWN_VENDOR_ID: 'UNKNOWN_VENDOR_ID',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  STARTING: 'STARTING',
} as const;

export type VendorErrorState =
  (typeof VendorErrorState)[keyof typeof VendorErrorState];
